// Location: assets/bal-announcement.js
// What: Switch header announcements without horizontal scrolling.
// Why: Preserve readable content, stable height, and accessible controls.
// RELEVANT FILES: sections/announcement-bar.liquid, assets/bal-announcement.css
class BalAnnouncement extends HTMLElement {
  connectedCallback() {
    this.slides = [...this.querySelectorAll('.bal-announcement__slide')];
    this.track = this.querySelector('.slider');
    if (!this.track || !this.slides.length) return;
    this.index = 0;
    this.manual = false;
    this.hovered = false;
    this.editing = false;
    this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.querySelectorAll('.slider-button').forEach((button) => {
      button.addEventListener('click', () => {
        this.manual = true;
        this.show(this.index + (button.name === 'next' ? 1 : -1));
        this.schedule();
      }, options);
    });
    this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
    this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
    this.addEventListener('focusin', () => this.schedule(), options);
    this.addEventListener('focusout', () => queueMicrotask(() => this.schedule()), options);
    document.addEventListener('visibilitychange', () => this.schedule(), options);
    this.motion.addEventListener('change', () => this.schedule(), options);
    this.addEventListener('shopify:block:select', (event) => {
      const index = this.slides.indexOf(event.target.closest('.bal-announcement__slide'));
      if (index < 0) return;
      this.editing = true;
      this.show(index);
      this.schedule();
    }, options);
    this.addEventListener('shopify:block:deselect', () => {
      this.editing = false;
      this.schedule();
    }, options);
    this.show(0);
    this.dataset.ready = '';
    this.schedule();
  }

  show(index) {
    this.index = (index + this.slides.length) % this.slides.length;
    this.slides.forEach((slide, position) => {
      const active = position === this.index;
      slide.setAttribute('aria-hidden', String(!active));
      slide.inert = !active;
      slide.querySelectorAll('a').forEach((link) => {
        if (active) link.removeAttribute('tabindex');
        else link.setAttribute('tabindex', '-1');
      });
    });
  }

  schedule() {
    clearTimeout(this.timer);
    if (!this.isConnected) return;
    const paused = this.track.dataset.autoplay !== 'true' || this.slides.length < 2 ||
      this.manual || this.hovered || this.editing || this.motion.matches || document.hidden ||
      this.contains(document.activeElement);
    this.track.setAttribute('aria-live', paused ? 'polite' : 'off');
    if (paused) return;
    this.timer = setTimeout(() => {
      this.show(this.index + 1);
      this.schedule();
    }, Math.max(3, Number(this.track.dataset.speed) || 5) * 1000);
  }

  disconnectedCallback() {
    clearTimeout(this.timer);
    this.controller?.abort();
  }
}
if (!customElements.get('bal-announcement')) customElements.define('bal-announcement', BalAnnouncement);
